import React, { useRef } from 'react';
import { formatText } from 'core/i18n';
import { InputText } from 'components/inputText/inputText';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { PASSWORD_LENGTH } from '../hooks/usePassword';
import { useObscurePassword } from './hooks/useObscurePassword';
import { getShowPasswordIconClass } from './utils/getShowPasswordIconClass';
import { getPasswordInputClass } from './utils/getPasswordInputClass';
import { usePasswordInputReset } from './hooks/usePasswordInputReset';

export const PasswordInput = ({
    handleValidations,
    handleOnChange,
    onFocus,
    onObscurePasswordChange,
    userProfile,
    userProfileForm,
    formActions,
    resetDependencies,
    hasErrors,
}) => {
    const inputRef = useRef();
    const {
        showPassword,
        handleShowPasswordClick,
        handleShowPasswordTouchStart,
        handleShowPasswordTouchEnd,
        handleShowPasswordChange,
    } = useObscurePassword({ onObscurePasswordChange });
    usePasswordInputReset({
        inputRef,
        handleShowPasswordChange,
        resetDependencies,
    });

    return (
        <div className="col-sm-6 md-form-group">
            <InputText
                innerRef={inputRef}
                profileModel="userProfile.password"
                label={formatText('field-createPassword')}
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                name="password"
                inputClass={getPasswordInputClass(showPassword)}
                onlyDigits
                maxLength={PASSWORD_LENGTH}
                id="password"
                autoCompletePassword="off"
                noFocusFromLabel
                isPassword
                placeholder={formatText('placeholder-password')}
                validations={handleValidations}
                onChange={handleOnChange}
                onFocus={onFocus}
                messagesError={{
                    required: formatText('validation-fieldRequired'),
                }}
                selectTextOnFocus={false}
                userProfileForm={userProfileForm}
                userProfile={userProfile}
                formActions={formActions}
                tooltip={<InfoTooltip text={formatText('tooltip-password')} />}
            />
            <i
                className={getShowPasswordIconClass(showPassword, hasErrors)}
                onClick={handleShowPasswordClick}
                onKeyDown={handleShowPasswordClick}
                onTouchStart={handleShowPasswordTouchStart}
                onTouchEnd={handleShowPasswordTouchEnd}
                role="button"
                tabIndex="0"
            />
        </div>
    );
};
